(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || !('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) return;

  const selector = [
    '.kh-section__intro',
    '.kh-categories .kh-section__heading',
    '.kh-category',
    '.kh-column',
    '.kh-spotlight__media',
    '.kh-spotlight__body',
    '.kh-story__inner',
    '.kh-demo__video',
  ].join(',');

  const fold = window.innerHeight * 0.92;
  const items = [...document.querySelectorAll(selector)].filter((el) => el.getBoundingClientRect().top > fold);

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting && entry.boundingClientRect.bottom > 0) return;
        entry.target.classList.add('kh-in');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -6% 0px' }
  );

  items.forEach((el) => {
    const index = [...el.parentElement.parentElement.children].indexOf(el.parentElement);
    el.style.setProperty('--kh-delay', `${Math.max(index, 0) * 70}ms`);
    el.classList.add('kh-reveal');
    observer.observe(el);
  });
})();
